import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadModuleUpdateDataRequest } from "../redux/Actions";
import ModuleMetaDataForm from "./ModuleMetaDataForm";

const ModuleMetaDataEdit = ({ handleClose, module }) => {
  const dispatch = useDispatch();
  let [submitted, setSubmitted] = useState(false);
  let [isClosing, setIsClosing] = useState(false);

  let { loading, error } = useSelector((state) => state.modules);

  // After submition, the post request is done loading, and there's no errors
  useEffect(() => {
    if (submitted && !loading && !isClosing) {
        setIsClosing(true);
        handleClose(true)
    }
}, [loading, dispatch, error, handleClose, isClosing, submitted])

  function submit(values) {
    dispatch(loadModuleUpdateDataRequest(values));
    setSubmitted(true);
  }
  function cancel() {
    handleClose(false);
  }
  return <ModuleMetaDataForm submit={submit} cancel={cancel} module={module} />;
};

export default ModuleMetaDataEdit;
